import { UniDriver, BaseUniDriver } from '@wix/wix-ui-test-utils/unidriver';
import { baseUniDriverFactory } from '../../utils/test-utils/unidriver';
import { ContentType } from './AvatarCore';

export interface AvatarCoreDriver extends BaseUniDriver {
  /** Get the currently displayed type. Types are: 'text', 'icon', 'image'. It could be that the resolved type is 'image' but the currently displayed one is `text`. */
  getContentType(): Promise<ContentType>;
  /** Get the text content (generated initials) */
  getTextContent(dataHook?: string): Promise<string>;
  /** Whether the image was loaded */
  isImageLoaded(): Promise<boolean>;
  /** Get the attribute value */
  getAttribute(attrName: string, dataHook?: string): Promise<string | null>;
  /** Get the property value */
  getProperty(propName: string): Promise<string | null>;

  hasClass(className: string, dataHook?: string): Promise<boolean>;
}

export const avatarCoreDriverFactory = (base: UniDriver): AvatarCoreDriver => {
  const byDataHook = (dataHook?: string) =>
    dataHook ? base.$(`[data-hook="${dataHook}"]`) : base;
  return {
    ...baseUniDriverFactory(base),
    getAttribute: (attrName, dataHook) => {
      if (dataHook) {
        return base.$(`[data-hook="${dataHook}"`).attr(attrName);
      }
      return base.attr(attrName);
    },
    getProperty: propName => base._prop(propName),
    getContentType: () =>
      base.attr('data-content-type') as Promise<ContentType>,
    getTextContent: dataHook => byDataHook(dataHook).text(),
    hasClass: (className, dataHook) => {
      return byDataHook(dataHook || 'content').hasClass(className);
    },
    isImageLoaded: async () => (await base.attr('data-img-loaded')) === 'true',
  };
};
